import src from "IMAGE";
export default { src, width: 5005, height: 908, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/webp;base64,UklGRkYAAABXRUJQVlA4TDkAAAAvBwAAEM1VICICEeGBQAIAAAAAnP8AMAAMAAAAAAAAAwAAAAAAAAAAAAAAAAAAAAAAAAAAxiFrsRMA"};
